import { Container } from "@material-ui/core";
import PageBackNavigation from "@saleor/components/PageBackNavigation";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation";
import CouponBulkSetCode from "@saleor/coupons/components/CouponBulkSetCode/CouponBulkSetCode";
import CouponManualSetCode from "@saleor/coupons/components/CouponManualSetCode";
import SetBulkUnlockCodesDialog from "@saleor/coupons/components/SetBulkUnlockCodesDialog/SetBulkUnlockCodesDialog";
import { useCouponDetailsForSetCodesQuery } from "@saleor/coupons/queries";
import { couponUrl } from "@saleor/coupons/url";
import useNavigator from "@saleor/hooks/useNavigator";
import React, { FC, useCallback, useState } from "react";

import useStyles from "./styles";

interface ICouponSetCodesPageProps {
  couponId: string;
}

const CouponSetCodesPage: FC<ICouponSetCodesPageProps> = props => {
  const { couponId } = props;
  const classes = useStyles(props);
  const navigate = useNavigator();

  const [isBulkUploadDialogShown, setIsBulkUploadDialogShown] = useState(false);

  const { data } = useCouponDetailsForSetCodesQuery({
    displayLoader: true,
    variables: { id: couponId }
  });

  const breadcrumbDirectory = [
    { name: data?.coupon.mainPromoTitle, url: couponUrl(couponId) },
    { name: "Set Codes" }
  ];

  const handleToggleBulkUploadDialogShown = useCallback(
    (isDialogShown: boolean) => () => {
      setIsBulkUploadDialogShown(isDialogShown);
    },
    [setIsBulkUploadDialogShown]
  );

  return (
    <Container>
      <PageBreadcrumbNavigation items={breadcrumbDirectory} />
      <div className={classes.backContainer}>
        <PageBackNavigation
          onBack={() => {
            navigate(couponUrl(couponId));
          }}
        />
        <span className={classes.title}>
          Set Codes {data?.coupon.code ? `for ${data?.coupon.code}` : null}
        </span>
      </div>

      <div className={classes.container}>
        <CouponManualSetCode couponId={data?.coupon.id} />
        <CouponBulkSetCode
          onButtonClick={handleToggleBulkUploadDialogShown(true)}
        />
      </div>
      {/* Dialog Here */}
      {isBulkUploadDialogShown && (
        <SetBulkUnlockCodesDialog
          onClose={handleToggleBulkUploadDialogShown(false)}
          couponId={couponId}
        />
      )}
    </Container>
  );
};

export default CouponSetCodesPage;
